module.exports = __webpack_public_path__ + "img/awards.3cdfd05.png";